<template>
  <div
    v-show="(record_modified?.id == recordHoverId && phasesHover) || recordClickId == record_modified?.id"
    :style="{ left: `-40vw`, width: `40vw`, marginTop: `${scrollTop * -1 + 80}px` }"
    class="absolute flex items-center text-white">
    <div
      v-for="(s_phase, j) in selectedJourney.phases.slice(0, selectedJourney.phases.length - 1)"
      :key="s_phase?.id"
      :style="{
        width: j === selectedJourney.phases.length - 2 ? '245vw' : '270vw',
        opacity: selectedJourney.phases.length - 1 - i <= j ? 1 : 0
      }"
      class="flex items-center">
      <div
        v-if="record_modified.history?.filter((h) => h.phase == selectedJourney.phases[j - (selectedJourney.phases.length - 1 - i)]?.id)[0]"
        class="p-2 py-1 text-sm bg-white border rounded-full text-dark-brand-blue border-dark-brand-blue dark:bg-dark-box-background">
        {{
          selectedJourney.phases
            .slice(0, j - (selectedJourney.phases.length - 1 - i))
            ?.filter((f) => record_modified.history?.filter((h) => h.phase == f?.id).length).length
            ? $t("Moved")
            : $t("Added")
        }}
        {{
          $moment(
            record_modified.history?.filter((h) => h.phase == selectedJourney.phases[j - (selectedJourney.phases.length - 1 - i)]?.id)[0]
              ?.logged_at
          ).fromNow()
        }}
      </div>
      <div
        v-else
        :style="{
          opacity: `${
            selectedJourney.phases
              .slice(0, j - (selectedJourney.phases.length - 1 - i))
              ?.filter((f) => record_modified.history?.filter((h) => h.phase == f?.id).length).length
              ? '1'
              : '0'
          }`
        }"
        class="w-full border-b text-dark-brand-blue border-dark-brand-blue" />
      <div
        :style="{
          opacity: `${
            record_modified.history?.filter((h) => h.phase == selectedJourney.phases[j - (selectedJourney.phases.length - 1 - i)]?.id)[0] ||
            selectedJourney.phases
              .slice(0, j - (selectedJourney.phases.length - 1 - i))
              ?.filter((f) => record_modified.history?.filter((h) => h.phase == f?.id).length).length
              ? '1'
              : '0'
          }`
        }"
        class="w-full border-b text-dark-brand-blue border-dark-brand-blue" />
    </div>
  </div>
  <div
    v-click-outside="handleClickOutside"
    :class="[
      `overflow-visible relative ${
        (phasesHover && recordHoverId === record?.id) || recordClickId == record?.id
          ? phase.records_count_change
            ? phase.records_count_change > 0
              ? 'bg-[#F1FFF9]'
              : 'bg-[#FDF5F5]'
            : 'bg-[#FFFCF1]'
          : 'bg-white'
      }   p-2 rounded-lg mb-4`
    ]"
    @mouseenter="handleRecordEnter(record_modified)"
    @mouseleave="handleRecordLeave()"
    @click="handleLockClick(record_modified)">
    <div class="border-b border-[#B3CAD6] dark:border-dark-divider-border p-3">
      <div class="flex items-center">
        <span v-if="utils.getDomainName(record_modified.values[utils.getOptionMetricReference('company', 'website')])" class="float-left">
          <img
            onerror="this.style.display='none'"
            class="inline-block rounded-md h-7 w-7"
            :src="utils.getRecordLogoUrl(record_modified)"
            alt="logo">
        </span>

        <div
          :class="{
            'ml-9': utils.getDomainName(record_modified.values[utils.getOptionMetricReference('company', 'website')])
          }"
          class="text-grey-light-body dark:text-dark-body-text max-w-[10px] text-lg absolute cursor-pointer has-tooltip"
          @click="utils.Record(record_modified).open()">
          {{ Record.from(record_modified).name?.slice(0, 16) }}{{ Record.from(record_modified).name?.length > 16 ? "..." : "" }}
          <span class="p-1 bg-gray-300 rounded-sm tooltip">
            <p class="text-sm font-medium dark:!text-white text-gray-700 group-hover:text-gray-900">
              {{ Record.from(record_modified).name }}
            </p>
          </span>
        </div>
        <div
          v-show="(record_modified?.id == recordHoverId && phasesHover) || recordClickId == record_modified?.id"
          class="absolute text-white right-10">
          <Lock
            v-if="recordClickId"
            class="w-6 h-6 mr-2 cursor-pointer text-red-error hover:text-gray-400 dark:hover:text-white"
            aria-hidden="true" />
          <LockOpen
            v-else
            class="w-6 h-6 mr-2 cursor-pointer text-common-grey hover:text-gray-400 dark:hover:text-white"
            aria-hidden="true" />
        </div>
        <input
          v-if="!editing_disabled"
          :checked="[...selectedRecords]?.filter((r) => r == record_modified?.id).length"
          type="checkbox"
          :class="[
            `form-checkbox w-4 ${
              phase.records_count_change
                ? phase.records_count_change > 0
                  ? 'text-status-success-green'
                  : 'text-status-error-red'
                : 'text-status-warning-yellow'
            } rounded h-4 dark:bg-dark-box-background ml-auto`
          ]"
          @click="(e) => handleCheckClick(e, record_modified)">
      </div>
      <div
        v-show="
          record_modified.history.length && ((record_modified?.id == recordHoverId && phasesHover) || recordClickId == record_modified?.id)
        "
        class="absolute p-2 py-1 mt-2 text-sm bg-white border rounded-full text-dark-brand-blue dark:bg-dark-box-background border-dark-brand-blue w-36">
        Moved
        {{
          record_modified.history.length ? $moment(record_modified.history[record_modified.history.length - 1]["logged_at"]).fromNow() : ""
        }}
      </div>
    </div>

    <div class="p-2 pb-0 leading-tight">
      <div v-if="$store.state.data.solid_metrics_phases[phase?.id]?.filter((stat) => stat.name == `Actual value`).length" class="flex my-2">
        <div class="text-common-grey">
          {{ $t("Actual Value") }}
        </div>
        <div class="ml-auto text-grey-light-body dark:text-dark-body-text">
          ${{ utils.truncateNumber(record_modified.base_value) }}
        </div>
      </div>
      <div
        v-if="$store.state.data.solid_metrics_phases[phase?.id]?.filter((stat) => stat.name == `Forecasted value`).length"
        class="flex my-2">
        <div class="text-common-grey">
          {{ $t("Forecasted Value") }}
        </div>
        <div class="ml-auto text-grey-light-body dark:text-dark-body-text">
          ${{ utils.truncateNumber(record_modified.forecasted_value) }}
        </div>
      </div>
      <div
        v-for="metric_id in phase.displayed_metrics_stats.filter((m) => $store.state.metrics.findIndex((metric) => metric.id == m) != -1)"
        :key="metric_id"
        class="flex my-2">
        <div class="text-common-grey w-[80%] text-ellipsis whitespace-nowrap overflow-hidden">
          {{ utils.getMetricById(metric_id)?.name }}
        </div>
        <div class="ml-auto text-grey-light-body dark:text-dark-body-text">
          {{
            record_modified.values[utils.getMetricById(metric_id).reference_name]
              ? utils.humanizeMetricValue(
                utils.getMetricById(metric_id),
                record_modified.values[utils.getMetricById(metric_id).reference_name]
              )
              : " - "
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Record } from "@/models/record"
import { Lock, LockOpen } from "lucide-vue-next"
import { utils } from "@/store/helpers"

export default {
  components: {
    Lock,
    LockOpen
  },
  inject: ["canUserEditLayout"],
  props: {
    scrollTop: {
      type: Number,
      default: 0
    },

    i: {
      type: Number,
      required: true
    },
    selectedJourney: {
      type: Object,
      required: true
    },
    record: {
      type: Object,
      required: true
    },
    phase: {
      type: Object,
      required: true
    },
    phasesHover: {
      type: Boolean,
      default: false
    },
    recordHoverId: {
      type: String,
      required: false
    },
    recordClickId: {
      type: String,
      required: false
    },

    handleLockClick: {
      type: Function,
      required: true
    },
    handleClickOutside: {
      type: Function,
      required: true
    },
    handleCheckClick: {
      type: Function,
      required: true
    },

    handleRecordEnter: {
      type: Function,
      required: true
    },
    handleRecordLeave: {
      type: Function,
      required: true
    },
    selectedRecords: {
      type: Set,
      required: true
    }
  },
  emits: ["update:selectedRecords"],
  data() {
    return {
      utils,
      Record
    }
  },

  computed: {
    editing_disabled() {
      let editing_disabled_calc = false
      if (this.$route.name == "WorkspaceItem" && this.$store.state.ui.workspace_user_access_scope == "read") {
        editing_disabled_calc = true
      }

      if (this.$route.name == "Dashboard" && this.$route.params.page) {
        const current_template = this.$store.state.portfolio.shared_layouts.find((l) => l.id == this.$route.params.page)
        if (!this.canUserEditLayout(this.$store.state.auth.user, current_template)) {
          editing_disabled_calc = true
        }
      }

      return editing_disabled_calc
    },
    record_modified() {
      // const history_dummy = [
      //   {
      //     phase: "fa166dbe-6b88-4e30-98eb-cfbd56b0ccdb",
      //     logged_at: "2023-03-09T22:46:26.071944+00:00",
      //     record_id: "0000e65c-f523-40e1-b7b2-dae527ab44b0",
      //     phase_name: "onboarding"
      //   },
      //   {
      //     phase: "f175f3f3-6013-4825-bd34-c6d70d79b4e1",
      //     logged_at: "2023-03-09T22:59:18.257881+00:00",
      //     record_id: "0000e65c-f523-40e1-b7b2-dae527ab44b0",
      //     phase_name: "adoption"
      //   },
      //   {
      //     phase: "3b831b05-e9de-4815-bd2a-be7ca96f202a",
      //     logged_at: "2023-03-09T22:59:18.257881+00:00",
      //     record_id: "0000e65c-f523-40e1-b7b2-dae527ab44b0",
      //     phase_name: "success"
      //   }
      // ]
      // return { ...this.record, history: history_dummy }
      return { ...this.record }
    }
  },
  methods: {}
}
</script>
